import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import s from './ModelConfigurationTabs.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { useParams } from 'react-router-dom';

const Tab = ({ selectedPage, pageComponent, url, title }) => (
  <Fragment>
    <Link className={classNames({ [s.active]: selectedPage === pageComponent })} to={url}>
      {title}
      {selectedPage === pageComponent && <span />}
    </Link>
  </Fragment>
);

const ModelTabs = ({ selectedPage, userProfileWidgets }) => {
  let { ModelCategoryId, ModelId } = useParams();
  return (
    <ul className={s.tabNav}>
      {IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTLIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variants-list`}
            title={<FormattedMessage id="modelTabs.modelVariants" defaultMessage="Model Variants" />}
            selectedPage={selectedPage}
            pageComponent="manageModelVariants"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTPOSITIONLIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-component-position-list`}
            title={<FormattedMessage id="modelTabs.modelComponentPositions" defaultMessage="Model Component Positions" />}
            selectedPage={selectedPage}
            pageComponent="manageModelComponentPositions"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELSETPOINTS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-setpoints-list`}
            title={<FormattedMessage id="modelTabs.modelSetpoints" defaultMessage="Model Setpoints" />}
            selectedPage={selectedPage}
            pageComponent="manageModelSetpoints"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'SEQUENCEVERSIONLIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/sequence-version`}
            title={<FormattedMessage id="modelTabs.modelSequences" defaultMessage="Model Sequences" />}
            selectedPage={selectedPage}
            pageComponent="manageModelSequences"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELTHRESHOLDS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-thresholds-list`}
            title={<FormattedMessage id="modelTabs.modelThresholds" defaultMessage="Model Thresholds" />}
            selectedPage={selectedPage}
            pageComponent="manageModelThresholds"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'PERIODICSUMMARYSETTINGS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/periodic-summary-settings-list`}
            title={<FormattedMessage id="modelTabs.periodicSummarySettings" defaultMessage="Periodic Summary Settings" />}
            selectedPage={selectedPage}
            pageComponent="periodicSummarySettings"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELSERVICEPLANS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/service-plan-list`}
            title={<FormattedMessage id="modelTabs.modelServicePlans" defaultMessage="Model Service Plans" />}
            selectedPage={selectedPage}
            pageComponent="manageModelServicePlans"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODEL_TELEMETRY_LINKS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-component-position-telemetry-links`}
            title={<FormattedMessage id="modelTabs.modelComponentPositionTelemetryLinks" defaultMessage="Model Component Position Telemetry Links" />}
            selectedPage={selectedPage}
            pageComponent="manageModelComponentPositionTelemetryLinks"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELFIRMWAREVERSIONLIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-firmware-version-list`}
            title={<FormattedMessage id="modelTabs.modelFirmwareVersions" defaultMessage="Model Firmware Versions" />}
            selectedPage={selectedPage}
            pageComponent="manageModelFirmwareVersions"
          />
        </li>
      )}


    </ul>
  )
};

ModelTabs.propTypes = {
  selectedPage: PropTypes.string.isRequired
};

export default ModelTabs;
